import { useState, useRef, useCallback, useEffect, useContext } from 'react';
import Images from 'assets/Images';
import { BIMContext } from 'providers/bim-provider';
import { colors } from 'config';
import { textFormatter } from 'utils';
import classNames from 'classnames';
import './style.scss';
import { AnimatePresence, motion } from 'framer-motion';
import { cloneDeep } from 'lodash';

const FactDropdown = props => {
	const { setAddNewFactPopup, setCreateObj } = useContext(BIMContext);
	const [dropdownToggle, setDropdownToggle] = useState(false);
	const [searchList, setSearchList] = useState([]);

	const dropdownOptionsRef = useRef();
	const dropdownDisplayRef = useRef();

	const { list, value, add, title, exact, none, search, index, onChange } = props;

	useEffect(() => {
		list?.length && setSearchList(list);
	}, [list]);

	const getFactbyId = (items, id) => {
		const a = id && items?.find(el => el?.fa_collection_field === id || el?.key === id);
		return textFormatter(a?.fa_name || a?.value) || '';
	};

	const dropdownHandler = () => {
		setDropdownToggle(prevState => !prevState);
	};

	// outside click handle function
	const handleClickOutside = useCallback(
		event => {
			if (dropdownOptionsRef?.current && !dropdownOptionsRef?.current?.contains(event?.target) && !dropdownDisplayRef?.current?.contains(event?.target)) {
				dropdownToggle && setDropdownToggle(false);
			}
		},
		[dropdownToggle, setDropdownToggle]
	);

	// outside click handler
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
			setSearchList(list);
		};
	}, [dropdownToggle, handleClickOutside]);

	// select the fact list
	const selectFactHandler = data => {
		onChange(data || '');
		setDropdownToggle(false);
	};

	const handleSearch = e => {
		setSearchList(list?.filter(el => el?.fa_name?.toLowerCase()?.includes(e?.toLowerCase())));
	};

	// fact list items in dropdown
	const factListItems = useCallback(
		() =>
			searchList?.map((el, i) => (
				<li key={i}>
					<span style={{ backgroundColor: colors[i % colors.length] }}>{el?.fa_key?.substring(0, 2) || el?.key?.substring(0, 2)}</span> {textFormatter(el?.fa_name || el?.value)}
					<div className='destination__add' onClick={() => selectFactHandler(el)}>
						<img src={Images?.addOperator} alt='add' />
					</div>
				</li>
			)),
		[searchList, list, dropdownToggle]
	);

	// selecting fact as none removeing all the links,formula,desField
	const handleClickNone = () => {
		selectFactHandler(null);
		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			const { bfm_serialNumber, bfm_fieldPosition, bfm_columnHeading } = data.bfm_uploadDetails[index];
			data.bfm_uploadDetails[index] = { id: index, bfm_serialNumber, bfm_fieldPosition, bfm_columnHeading, bfm_desField: '', bfm_formula: '', bfm_linkedSNo: '' };
			return data;
		});
	};

	return (
		<>
			{list?.length && (
				<div ref={dropdownOptionsRef} className='destination'>
					<div ref={dropdownDisplayRef} className='destination__display' onClick={dropdownHandler}>
						{getFactbyId(list, value)}
					</div>

					<AnimatePresence>
						{dropdownToggle && (
							<motion.div
								initial={{ y: -10, opacity: 0 }}
								animate={{ y: 0, opacity: 1 }}
								exit={{ y: -10, opacity: 0 }}
								transition={{ duration: 0.2 }}
								className={classNames({ destination__container: true, 'destination__container--exact': exact })}
							>
								<h5>{title}</h5>
								{search && (
									<div className='destination__search'>
										<div className='destination__search--img'>
											<img src={Images?.search} alt='search' />
										</div>
										<input placeholder='Search' onChange={e => handleSearch(e?.target?.value)} />
									</div>
								)}
								<ul className='scroll-bar destination__list'>
									{none && (
										<li>
											<span style={{ backgroundColor: colors[0 % colors.length] }}>NO</span> None
											<div className='destination__add'>
												<img src={Images?.addOperator} alt='add' onClick={handleClickNone} />
											</div>
										</li>
									)}
									{factListItems()}
									{add && (
										<li>
											<span style={{ backgroundColor: colors[0 % colors.length] }}>AN</span> Add New
											<div className='destination__add'>
												<img src={Images?.addOperator} alt='add' onClick={() => setAddNewFactPopup(index)} />
											</div>
										</li>
									)}
								</ul>
							</motion.div>
						)}
					</AnimatePresence>
				</div>
			)}
		</>
	);
};

export default FactDropdown;
